import React, { Component } from 'react';
import styled from '@emotion/styled';
import Ratings from 'react-ratings-declarative';

const Container = styled('div')`
  text-align: center;

  /* Library overrides, 'important' sadly needed :( */
  .widget-svg {
    /* Remove scale in effect from library */
    transform: none !important;
  }

  .widget-ratings {
    display: flex !important;
    max-width: 180px;
    max-height: 50px;
  }
`;

class StarSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rating: props.rating || 0,
    };
  }

  changeRating = (newRating) => {
    this.setState({
      rating: newRating,
    });
    this.props.form.setFieldValue('resourceRating', newRating);
  };

  render() {
    return (
      <Container>
        <Ratings
          rating={this.state.rating}
          changeRating={this.changeRating}
          widgetRatedColors={this.props.color}
          widgetHoverColors={this.props.color}
          widgetDimensions="32px"
          widgetSpacings="0px"
        >
          <Ratings.Widget />
          <Ratings.Widget />
          <Ratings.Widget />
          <Ratings.Widget />
          <Ratings.Widget />
        </Ratings>
      </Container>
    );
  }
}

export default StarSelector;
